import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { t } from 'i18next';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminMessageState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}

const defaultColumnList = [
  {
    name: 'to',
    label_key: 'send_to',
    allow_list: false,
    allow_filter: true,
    show_list_checkbox: false,
    show_filter_checkbox: true,
    type: 'select',
    selectKey: 'message_to_list',
    filter_placeholder: t('colon_all', { key: t('send_to') }),
    option_value_key: 'slug',
    option_label_key: 'name',
    multi: false,
    order: 1,
  },
  {
    name: 'message',
    label_key: 'message',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'created_at',
    label_key: 'date_sent',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
];

const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));

const initialState: AdminMessageState = {
  excludedFilter: ['search'],
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminMessageSlice = createSlice({
  name: 'adminMessage',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = action.payload;
    },
    removeFilterKey(state, action: PayloadAction<string>) {
      delete state.filterData[action.payload];
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setMessageTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setFilterData,
  removeFilterKey,
  resetFilterData,
  setReloadTableData,
  setMessageTableColumnList,
} = adminMessageSlice.actions;

export default adminMessageSlice.reducer;
